import React, { useState } from "react";
import styles from './Search.module.scss';
import SearchIcon from './Search.svg';
import PropTypes from "prop-types";

const Search = ({
  placeholder = 'Search',
  onSubmit
}) => {
  const [keyword, setKeyword] = useState('');

  const hanldeSearch = () => {
    onSubmit(keyword);
  };

  return (
    <form 
      className={styles.search}
      onSubmit={(e) => {
        e.preventDefault();
        hanldeSearch();
      }}
    >
      <input 
        type="text"
        placeholder={placeholder}
        value={keyword}
        onChange={({ target: { value } })=> {
          setKeyword(value);
        }}
      />
      <button type="submit">
        <img src={SearchIcon} alt="Search" />
      </button>
    </form>
  );
};

Search.propTypes = {
  placeholder: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
}

export default Search;